/**
 * Normalized API origin (no trailing slash).
 * In development, use relative URLs so CRA proxies /api to the backend.
 */
export function getApiBaseUrl() {
  if (process.env.NODE_ENV === "development") {
    return "";
  }
  const raw =
    process.env.REACT_APP_API_BASE_URL?.trim() || "https://api.vuca.li";
  return raw.replace(/\/$/, "");
}

/**
 * Media origin for /uploads/... paths.
 * In development, relative paths are proxied to the backend.
 */
export function getMediaBaseUrl() {
  if (process.env.NODE_ENV === "development") {
    return "";
  }
  const raw =
    process.env.REACT_APP_MEDIA_BASE_URL?.trim() ||
    process.env.REACT_APP_API_BASE_URL?.trim() ||
    "https://api.vuca.li";
  return raw.replace(/\/$/, "");
}
